import React from "react";
import styled from "styled-components";
import Input from "../Input/Input";
import { AiOutlineGithub } from "react-icons/ai";
import { AiOutlineLinkedin } from "react-icons/ai";
import { AiOutlineMail } from "react-icons/ai";
import { FaLocationArrow } from "react-icons/fa";

function Contact() {
  return (
    <Container>
      <section>
        <h1 className="contact-title" id="contact">
          Contact Me
        </h1>
        <div className="container-flex">
          <div className="contact-info">
            <div className="box">
              <div className="icon">
                <AiOutlineMail />
              </div>
              <div className="text">
                <h3>Email</h3>

                <p>willcordeiro800@gmail.com</p>
              </div>
            </div>
            <div className="box">
              <div className="icon">
                <FaLocationArrow />
              </div>
              <div className="text">
                <h3>Address</h3>

                <p>Brazil, Rio das Ostras</p>
              </div>
            </div>

            <h2 className="txt">Connect with me</h2>
            <ul className="sci">
              <li>
                <a
                  href="https://github.com/willcordeiro"
                  target="blank"
                  name="github"
                >
                  {" "}
                  <AiOutlineGithub />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/in/william-cordeiro-568229238/"
                  target="blank"
                  name="linkedin"
                >
                  <AiOutlineLinkedin />
                </a>
              </li>
            </ul>
          </div>

          <form action="https://formspree.io/f/xpznlvgg" method="POST">
            <span className="input-span">Your Name</span>
            <Input type="text" name="name" />
            <span className="input-span">Your Email</span>
            <Input type="email" name="email" />
            <span className="input-span">Subject</span>
            <Input type="subject" name="subject" />
            <span className="input-span">Message</span>
            <textarea type="text" name="message" required />
            <Input type="submit" value="Send!" submit={true} />;
          </form>
        </div>
      </section>
    </Container>
  );
}

export default Contact;

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #181818;

  .contact-title {
    margin-bottom: 100px;
    color: white;
  }

  span {
    color: var(--color-white);
    font-weight: bold;
  }
  .input-span {
    color: #afb1b3;
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: linear-gradient(to right bottom, #1c1b29 50%, #292841 50%);
    border-radius: 7px;
    padding: 3rem 2.5rem;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px,
      rgba(0, 0, 0, 0.3) 0px 7px 13px -3px,
      rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
  }

  textarea {
    background-color: white;
    padding: 1rem;
    border: none;
    border-radius: 3px;
    height: 80px;
    width: 400px;
    font-size: 1rem;
    font-family: system-ui;
    &:focus {
      background-color: #e9e9e9;
      font-family: system-ui;
    }
  }

  .contact-info {
    min-height: 500px;
    color: white;
    min-width: 100%;
  }

  .contact-form {
    position: relative;
    display: flex;
    min-height: 500px;
    min-width: 100%;
  }

  .container-flex {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    gap: 50px;
  }

  .box {
    position: relative;
    padding: 20px 0;
    display: flex;
  }

  .icon {
    min-width: 60px;
    height: 60px;
    background-color: var(--color-light);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.75em;
    border-radius: 50%;
  }

  .icon:hover {
    background-color: var(--color-primary);
  }

  .text {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    font-size: 1.1em;
    font-weight: 300;
  }

  .text h3 {
    font-weight: 600;
    color: white;
  }

  .txt {
    margin-top: 50px;
    font-weight: 500;
    font-size: 1.1em;
    padding-left: 10px;
    border-left: 50px solid #c21a54;
    line-height: 1em;
    color: white;
  }

  .sci {
    position: relative;
    display: flex;
    gap: 30px;
    margin: 20px 0;
  }

  .sci li a {
    font-size: 3em;
    color: var(--color-light);
  }

  .sci li a:hover {
    background-color: #c21a54;
    border-radius: 50%;
  }

  @media screen and (max-width: 768px) {
    .container-flex {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 2fr;
    }

    textarea {
      width: 300px;
    }
  }
`;
